import { Table } from 'antd';
import React from 'react'
import { Tooltip } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Select from 'react-select';

const PreAlert = () => {

const navigate = useNavigate();

const organisationOptions = [
{ value: 1, label: "Organisation 1" },
{ value: 2, label: "Organisation 2" },
{ value: 3, label: "Organisation 3" },
{ value: 4, label: "Organisation 4" },
{ value: 5, label: "Organisation 5" },
];

const portOptions = [
{ value: 1, label: "Port 1" },
{ value: 2, label: "Port 2" },
{ value: 3, label: "Port 3" },
{ value: 4, label: "Port 4" },
{ value: 5, label: "Port 5" },
]

const columns = [
{ title: "Source Company", dataIndex: "sourceCompany", key: "sourceCompany" },
{ title: "Source Location", dataIndex: "sourceLocation", key: "sourceLocation" },
{ title: "Pre Alert No.", dataIndex: "preAlertNo", key: "preAlertNo" },
{ title: "Consol No.", dataIndex: "consolNo", key: "consolNo" },
{ title: "Shipper", dataIndex: "shipper", key: "shipper" },
{ title: "Consignee", dataIndex: "consignee", key: "consignee" },
{ title: "Pre Alert Date", dataIndex: "preAlertDate", key: "preAlertDate" },
{ title: "Consol Type", dataIndex: "consolType", key: "consolType" },
{ title: "Orig Agent/Shipper", dataIndex: "origAgentShipper", key: "origAgentShipper" },
{ title: "Dest Agent/Consignee", dataIndex: "destAgentConsignee", key: "destAgentConsignee" },
{ title: "Load Port", dataIndex: "loadPort", key: "loadPort" },
{ title: "Disch Port", dataIndex: "dischPort", key: "dischPort" },
{ title: "MAWB No.", dataIndex: "mawbNo", key: "mawbNo" },
{ title: "Packages", dataIndex: "packages", key: "packages" },
{ title: "No. of Houses", dataIndex: "numberOfHouses", key: "numberOfHouses" },
{ title: "Airline", dataIndex: "airline", key: "airline" },
{ title: "Flight No", dataIndex: "flightNo", key: "flightNo" },
{ title: "Flight Date", dataIndex: "flightDate", key: "flightDate" },
{ title: "Action", dataIndex: "action", key: "action" },
];

const dataSource = [
{
key: "1", // Add a unique key for each row
SNo: "1", // Changed to camelCase
Joborderno: "CARGO_1233",
Trackingno: "CC_1233",
Date: "12-Aug-2024",
Transportmode: "Air",
Transporttype: "Import",
Shipper: "Abhishek",
Consignee: "Ravi",
Originagent: "Abhishek",
Destinationagent: "Ravi",
Masternotify: "YES",
Loadingport: "Mumbai",
Dischargeport: "Delhi",
Shipmentno: "8687",
Goodsexpected: "YES",
Carrierbooking: "YES",
Status:
<>
    <span className={`cursor-pointer badge badge-pill badge-status bg-success `}>Active</span>
</>
,
action: (
<div className="dropdown table-action">
    <Link to="#" className="action-icon" data-bs-toggle="dropdown">
    <i className="fa fa-ellipsis-v"></i>
    </Link>
    <div className="dropdown-menu dropdown-menu-right">
        <div className="dropdown-item cursor-pointer">
            <i className="ti ti-edit text-blue me-2"></i> Edit
        </div>
    </div>
</div>
)
},
{
key: "2", // Add a unique key for each row
SNo: "2", // Changed to camelCase
Joborderno: "CARGO_1234",
Trackingno: "CC_1243",
Date: "10-Aug-2024",
Transportmode: "Sea",
Transporttype: "Export",
Shipper: "Abhishek",
Consignee: "Ashish",
Originagent: "Abhishek",
Destinationagent: "Rohit",
Masternotify: "YES",
Loadingport: "Pune",
Dischargeport: "Delhi",
Shipmentno: "8687",
Goodsexpected: "YES",
Carrierbooking: "NO",
Status:
<>
    <span className={`cursor-pointer badge badge-pill badge-status bg-danger `}>Inactive</span>
</>
,
action: (
<div className="dropdown table-action">
    <Link to="#" className="action-icon" data-bs-toggle="dropdown">
    <i className="fa fa-ellipsis-v"></i>
    </Link>
    <div className="dropdown-menu dropdown-menu-right">
        <div className="dropdown-item cursor-pointer">
            <i className="ti ti-edit text-blue me-2"></i> Edit
        </div>

    </div>
</div>
)
},

{
key: "3", // Add a unique key for each row
SNo: "3", // Changed to camelCase
Joborderno: "CARGO_1257",
Trackingno: "CC_1257",
Date: "12-Aug-2024",
Transportmode: "Rail",
Transporttype: "Domestic",
Shipper: "Rohit",
Consignee: "Ravi",
Originagent: "Sakshi",
Destinationagent: "Shweta",
Masternotify: "YES",
Loadingport: "Kolkata",
Dischargeport: "Los Angeles",
Shipmentno: "8690",
Goodsexpected: "NO",
Carrierbooking: "YES",
Status:
<>
    <span className={`cursor-pointer badge badge-pill badge-status bg-success `}>Active</span>

</>
,
action: (
<div className="dropdown table-action">
    <Link to="#" className="action-icon" data-bs-toggle="dropdown">
    <i className="fa fa-ellipsis-v"></i>
    </Link>
    <div className="dropdown-menu dropdown-menu-right">
        <div className="dropdown-item cursor-pointer">
            <i className="ti ti-edit text-blue me-2"></i> Edit
        </div>

    </div>
</div>
)
}
];
return (
<>
    <div className="page-wrapper">
        <div className="content">
            <div className="row">
                <div className="col-md-12">
                    {/* Page Header */}
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-8">
                                <h4 className="page-title">
                                    Air Import Pre Alert<span className="count-title">3</span>
                                </h4>
                            </div>
                            <div className="col-4 text-end">
                                <div className="head-icons">
                                    <a href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top"
                                        data-bs-original-title="Collapse" id="collapse-header">
                                        <i className="ti ti-chevrons-up" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Page Header */}
                </div>
            </div>
            <div className="card">

                <div className="card-body">
                <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="" className="form-label mb-0">Status</label>
                                                    <select className="form-control form-control-sm">
                                                        <option selected>New</option>
                                                        <option>In Progress</option>
                                                    </select>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="" className="form-label mb-0">Pre Alert No.</label>
                                                    <input type="text" className="form-control form-control-sm" />
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="" className="form-label mb-0">Load Port</label>
                                                    <input type="text" className="form-control form-control-sm" />
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="" className="form-label mb-0">Cargo Type</label>
                                                    <select className="form-control form-control-sm">
                                                        <option>Any</option>
                                                        <option>Loose</option>
                                                        <option>ULD</option>
                                                    </select>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="" className="form-label mb-0">Source</label>
                                                    <select className="form-control form-control-sm">
                                                        <option selected>All</option>
                                                    </select>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="" className="form-label mb-0">Consol No.</label>
                                                    <input type="text" className="form-control form-control-sm" />
                                                </div>

                                                
                                                <div className="col-md-3">
                                                    <label htmlFor="" className="form-label mb-0">Disch. Port</label>
                                                    <input type="text" className="form-control form-control-sm" />
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="" className="form-label mb-0">MAWB No.</label>
                                                    <input type="text" className="form-control form-control-sm" />
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="" className="form-label mb-0">Entry Date</label>
                                                    <input type="text" className="form-control form-control-sm"
                                                        placeholder="DD.MM.YY - DD.MM.YY" />
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="" className="form-label mb-0">Consol Type</label>
                                                    <select className="form-control form-control-sm">
                                                        <option selected>(All)</option>
                                                    </select>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="" className="form-label mb-0">Shipment Type</label>
                                                    <select className="form-control form-control-sm">
                                                        <option selected>Any</option>
                                                    </select>
                                                </div>
                                                {/* <div className="col-md-3 d-flex align-items-end">
                                                    <button className="btn btn-primary btn-sm w-100">Search</button>
                                                </div>
                                             */}

                                            </div>


                                        </div>
                                    </div>

                    {/* Filter */}
                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                        <div className="d-flex align-items-center flex-wrap row-gap-2">
                            <div className="dropdown me-2">
                                <a href="javascript:void(0);" className="dropdown-toggle" data-bs-toggle="dropdown">
                                    <i className="ti ti-sort-ascending-2 me-2" />
                                    Sort{" "}
                                </a>

                                <div className="dropdown-menu  dropdown-menu-start">

                                    <ul>
                                        <li>
                                            <a href="javascript:void(0);" className="dropdown-item">
                                                <i className="ti ti-circle-chevron-right me-1" />
                                                Ascending
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0);" className="dropdown-item">
                                                <i className="ti ti-circle-chevron-right me-1" />
                                                Descending
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0);" className="dropdown-item">
                                                <i className="ti ti-circle-chevron-right me-1" />
                                                Recently Viewed
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0);" className="dropdown-item">
                                                <i className="ti ti-circle-chevron-right me-1" />
                                                Recently Added
                                            </a>
                                        </li>
                                    </ul>
                                   

                                </div>
                            </div>
                            <div className="icon-form mb-3 mb-sm-0">
                                <span className="form-icon">
                                    <i className="ti ti-search" />
                                </span>
                                <input type="text" className="form-control form-control-sm" placeholder="Search "
                                    name='search_by' />
                            </div>
                            <div className="form-sorts dropdown ms-2">
                                <Tooltip placement="top" title="Filter">
                                    <a href="javascript:void(0);" data-bs-toggle="dropdown" data-bs-auto-close="outside"
                                        className='py-1' style={{
                                                    paddingTop: "7px",
                                                    paddingBottom: "6px"
                                                }}>
                                        <i className="ti ti-filter-share me-0" />
                                        {/* Filter */}
                                    </a>
                                </Tooltip>
                                <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3">
                                    <div className="filter-set-view">
                                        <table className="content-table">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <label htmlFor="#">Shipment No.</label>
                                                    </td>
                                                    <td className="input_box_filter">
                                                        {" "}
                                                        <input type="text" className="form-control form-control-sm ms-2"
                                                            placeholder="Enter Shipment No." name="email" />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <label htmlFor="#">HAWB No.</label>
                                                    </td>
                                                    <td className="input_box_filter">
                                                        {" "}
                                                        <input type="text" className="form-control form-control-sm ms-2"
                                                            placeholder="Enter HAWB No." name="email" />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <label htmlFor="#">AWB No.</label>
                                                    </td>
                                                    <td className="input_box_filter">
                                                        {" "}
                                                        <input type="text" className="form-control form-control-sm ms-2"
                                                            placeholder="Enter AWB No." name="email" />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <label htmlFor="#">Shipment No.</label>
                                                    </td>
                                                    <td className="input_box_filter">
                                                        {" "}
                                                        <input type="text" className="form-control form-control-sm ms-2"
                                                            placeholder="Enter Shipment no." name="email" />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <label htmlFor="#">Shipment from</label>
                                                    </td>
                                                    <td className="input_box_filter">
                                                        {" "}
                                                        <input type="date" className="form-control form-control-sm ms-2"
                                                            placeholder="Enter Prefix" name="email" />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <label htmlFor="#">Shipment To</label>
                                                    </td>
                                                    <td className="input_box_filter">
                                                        {" "}
                                                        <input type="date" className="form-control form-control-sm ms-2"
                                                            placeholder="Enter Prefix" name="email" />
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        <label htmlFor="#">Active</label>
                                                    </td>
                                                    <td className="input_box_filter">
                                                        {" "}
                                                        <select className='form-control form-control-sm ms-2'>
                                                            <option value="YES">YES</option>
                                                            <option value="NO">NO</option>
                                                        </select>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        <label htmlFor="#">Console Type</label>
                                                    </td>
                                                    <td className="input_box_filter">

                                                        <select className='form-control form-control-sm ms-2'>
                                                            <option value="ALL">All</option>
                                                            <option value="1">Direct</option>
                                                            <option value="2">Buyer Consol</option>
                                                            <option value="2">Agent Consol</option>
                                                            <option value="1">Back to Back</option>
                                                        </select>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <label htmlFor="#">Status</label>
                                                    </td>
                                                    <td className="input_box_filter">

                                                        <select className='form-control form-control-sm ms-2'>
                                                            <option selected> All </option>
                                                            <option> Booking Received from Shipper </option>
                                                            <option> Job Order Created </option>
                                                            <option> Carrier Booking </option>
                                                            <option> Goods Received </option>
                                                            <option> S/B Filed </option>
                                                            <option> Shipment Created </option>
                                                            <option> Customs Formalities at Origin </option>
                                                            <option> Goods Carted </option>
                                                            <option> Goods Examined </option>
                                                            <option> Goods Handed Over </option>
                                                            <option> Loaded on Carrier </option>
                                                            <option> Goods Carted </option>
                                                            <option> Reached at Destination </option>
                                                            <option> Goods Delivered </option>
                                                            <option> Flight One Departed </option>
                                                            <option> Billing </option>
                                                            <option> Cargo Arrival Notice Sent </option>
                                                            <option> DO Issued </option>
                                                            <option> Customs Formalities at Destination </option>
                                                            <option> Pending </option>
                                                        </select>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <label htmlFor="#">Shipper</label>
                                                    </td>
                                                    <td className="input_box_filter">
                                                        {" "}
                                                        <Select id="Shipper" className='mt-2 custom-selector w-100'
                                                            options={organisationOptions} name="role_id" />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <label htmlFor="#">Consignee</label>
                                                    </td>
                                                    <td className="input_box_filter">
                                                        {" "}
                                                        <Select id="Shipper" className='mt-2 custom-selector w-100'
                                                            options={organisationOptions} name="role_id" />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <label htmlFor="#">Load Port</label>
                                                    </td>
                                                    <td className="input_box_filter">
                                                        {" "}
                                                        <Select id="Shipper" className='mt-2 custom-selector w-100'
                                                            options={portOptions} name="role_id" />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <label htmlFor="#">Discharge Port</label>
                                                    </td>
                                                    <td className="input_box_filter">
                                                        {" "}
                                                        <Select id="Shipper" className='mt-2 custom-selector w-100'
                                                            options={portOptions} name="role_id" />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div className="filter-reset-btns">
                                            <div className="row">
                                                <div className="col-6">
                                                    <a className="btn btn-light">
                                                        Reset
                                                    </a>
                                                </div>
                                                <div className="col-6">
                                                    <button type='submit' className="btn btn-primary w-100">
                                                        Filter
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-center flex-wrap row-gap-2">
                            <Tooltip placement="top" title="Print Data">
                                <div className="btn btn-primary cursor-pointer me-2">
                                    <i className="ti ti-printer text-white"></i>
                                    {/*
                                    <ReactTooltip id="print" place="top" effect="solid" /> */}
                                </div>
                            </Tooltip>
                            <Tooltip placement="top" title="Export Data">
                                <div className="btn btn-primary cursor-pointer me-2">
                                    <i className="fas fa-file-export text-white"></i>
                                    {/*
                                    <ReactTooltip id="export" place="top" effect="solid" /> */}
                                </div>
                            </Tooltip>
                            <button type='submit' className="btn btn-primary me-2">
                                Search
                            </button>
                            <a className='btn btn-light me-2' //
                                style={{ background: "#04aed2", marginTop: "7px", marginBottom: "7px" }}>
                                Clear
                            </a>
                         

                        </div>
                    </div>
                    {/* /Filter */}
                    {/* Contact List */}

                    <div className="table-responsive custom-table">
                        <Table className="table datanew dataTable no-footer" pagination={false} dataSource={dataSource}
                            columns={columns} />
                    </div>
                </div>
            </div>
        </div>
    </div>
</>
)
}

export default PreAlert